import { LocationEditorProps, LocationEditorState } from '../../types'
import { getLocationDisplayText } from '../../utils/getLocationDisplayText'

export function computeInitialState(props: LocationEditorProps): LocationEditorState {
  const { location, assets } = props
  return {
    textFieldValue: getLocationDisplayText(location),
    textFieldDirty: false,
    open: false,
    dropdownSelectedIndex: -1,
    dropdownOptions: assets,
  }
}
